import React from "react";

// The home page's "Shop by" section: its heading, the chips (an emoji and one of the store's categories, a tap opens
// the category) and the "under ₹…" price tiles. Empty fields and lists keep the defaults for the store's kind; with
// no chips chosen the store shows its own categories.
const MAX_CHIPS = 12;
const MAX_BUDGETS = 4;

export default function ShopByEditor({ value, onChange, categories = [] }) {
  const v = value;
  const set = (changes) => onChange({ ...v, ...changes });
  const setItem = (i, changes) => set({ items: v.items.map((x, j) => (j === i ? { ...x, ...changes } : x)) });
  const unused = categories.filter((c) => !v.items.some((x) => x.name === c));
  const setBudget = (i, amount) => set({ budgets: v.budgets.map((x, j) => (j === i ? amount : x)) });

  return (
    <div className="shop-by-editor">
      <div className="field-section-title">Shop by section</div>
      <p className="field-help">The section with category chips and "under ₹…" price tiles on your home page. Leave a field empty to keep the default.</p>
      <label className="personalization-row"><input type="checkbox" checked={!v.off} onChange={(e) => set({ off: !e.target.checked })} /> Show this section on my home page</label>
      {!v.off && (
        <>
          <label className="admin-field">Small heading<input value={v.eyebrow} maxLength={60} onChange={(e) => set({ eyebrow: e.target.value })} placeholder="e.g. 🕰️ Handmade for your walls" /></label>
          <label className="admin-field">Title<input value={v.title} maxLength={60} onChange={(e) => set({ title: e.target.value })} placeholder="e.g. Shop by category" /></label>
          <label className="admin-field">Description<textarea rows="2" value={v.subtitle} maxLength={200} onChange={(e) => set({ subtitle: e.target.value })} placeholder="e.g. Resin wall clocks, couple frames and pooja keepsakes." /></label>

          <b className="shop-by-label">Category chips <em>{v.items.length ? `${v.items.length} chosen` : "none chosen: all your categories show"}</em></b>
          {v.items.map((x, i) => (
            <div className="shop-by-row" key={i}>
              <input className="shop-by-icon" value={x.icon} maxLength={16} onChange={(e) => setItem(i, { icon: e.target.value })} placeholder="🕰️" aria-label={`Chip ${i + 1} emoji`} />
              <select value={x.name} onChange={(e) => setItem(i, { name: e.target.value })} aria-label={`Chip ${i + 1} category`}>
                {!categories.includes(x.name) && <option value={x.name}>{x.name}</option>}
                {categories.filter((c) => c === x.name || unused.includes(c)).map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
              <button type="button" className="size-price-remove" onClick={() => set({ items: v.items.filter((_, j) => j !== i) })} aria-label={`Remove chip ${i + 1}`}>×</button>
            </div>
          ))}
          <button type="button" className="outline-btn" disabled={!unused.length || v.items.length >= MAX_CHIPS} onClick={() => set({ items: [...v.items, { icon: "", name: unused[0] }] })}>+ Add category chip</button>

          <b className="shop-by-label">Price tiles <em>{v.budgets.length ? `${v.budgets.length} tiles` : "none: the default amounts show"}</em></b>
          <label className="admin-field">Text above the amount<input value={v.budgetPrefix} maxLength={40} onChange={(e) => set({ budgetPrefix: e.target.value })} placeholder="e.g. Clocks under" /></label>
          {v.budgets.map((amount, i) => (
            <div className="shop-by-row" key={i}>
              <span className="shop-by-rupee">₹</span>
              <input type="number" min="1" value={amount} onChange={(e) => setBudget(i, e.target.value === "" ? "" : Number(e.target.value))} placeholder="e.g. 1499" aria-label={`Price tile ${i + 1} amount`} />
              <button type="button" className="size-price-remove" onClick={() => set({ budgets: v.budgets.filter((_, j) => j !== i) })} aria-label={`Remove price tile ${i + 1}`}>×</button>
            </div>
          ))}
          <button type="button" className="outline-btn" disabled={v.budgets.length >= MAX_BUDGETS} onClick={() => set({ budgets: [...v.budgets, ""] })}>+ Add price tile</button>
        </>
      )}
    </div>
  );
}
